define('modules/uv-shared-module/Position',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Position;
    (function (Position) {
        Position[Position["TOP_LEFT"] = 0] = "TOP_LEFT";
        Position[Position["TOP_CENTER"] = 1] = "TOP_CENTER";
        Position[Position["TOP_RIGHT"] = 2] = "TOP_RIGHT";
        Position[Position["CENTER_LEFT"] = 3] = "CENTER_LEFT";
        Position[Position["CENTER"] = 4] = "CENTER";
        Position[Position["CENTER_RIGHT"] = 5] = "CENTER_RIGHT";
        Position[Position["BOTTOM_LEFT"] = 6] = "BOTTOM_LEFT";
        Position[Position["BOTTOM_CENTER"] = 7] = "BOTTOM_CENTER";
        Position[Position["BOTTOM_RIGHT"] = 8] = "BOTTOM_RIGHT";
    })(Position = exports.Position || (exports.Position = {}));
});
//# sourceMappingURL=Position.js.map
